var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(0 1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m3.255 10.04v-.493c0-1.878 1.52-3.4 3.397-3.4h11.271a3.399 3.399 0 0 1 3.392 3.399v.493h1.837a.54.54 0 0 1 .54.54v2.585a.54.54 0 0 1 -.54.54h-1.837v3.244c0 1.878-1.52 3.4-3.397 3.4h-4.762a.14.14 0 0 0 -.1.045l-3.826 4.073a.475.475 0 0 1 -.822-.324v-3.652a.14.14 0 0 0 -.139-.14h-1.617a3.395 3.395 0 0 1 -2.403-.996 3.403 3.403 0 0 1 -.994-2.405v-3.246h-1.755a.54.54 0 0 1 -.54-.539v-2.586a.54.54 0 0 1 .54-.539h1.754z",
  stroke: "#ff4438",
  strokeWidth: 1.797
}), /*#__PURE__*/React.createElement("path", {
  d: "m10.511 11.3-1.747 1.766a.143.143 0 0 1 -.203 0l-1.744-1.761a1.088 1.088 0 0 1 0-1.528 1.06 1.06 0 0 1 1.512 0l.232.235a.143.143 0 0 0 .203 0l.236-.238c.268-.28.666-.393 1.039-.294s.665.393.763.77c.098.378-.013.78-.29 1.05m7.581 0-1.747 1.766a.143.143 0 0 1 -.203 0l-1.744-1.761a1.088 1.088 0 0 1 0-1.528 1.06 1.06 0 0 1 1.512 0l.232.235a.143.143 0 0 0 .203 0l.236-.238c.268-.28.666-.393 1.039-.294s.665.393.763.77c.098.378-.013.78-.29 1.05",
  fill: "#fff",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#fff"
}, /*#__PURE__*/React.createElement("g", {
  strokeWidth: 0.719
}, /*#__PURE__*/React.createElement("path", {
  d: "m8.709 2.565v2.932",
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 8.709,
  cy: 1.099,
  rx: 1.083,
  ry: 1.099
}), /*#__PURE__*/React.createElement("path", {
  d: "m16.291 2.565v2.932",
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 16.291,
  cy: 1.099,
  rx: 1.083,
  ry: 1.099
})), /*#__PURE__*/React.createElement("path", {
  d: "m8.715 16.49c1.586.664 2.794.995 3.623.995s2.036-.331 3.622-.995",
  strokeLinecap: "round",
  strokeWidth: 1.042
})));
var SvgBotLight = function SvgBotLight(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 27,
    viewBox: "0 0 25 27",
    width: 25,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBotLight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/BotLight.65c2c01c.svg";
export { ForwardRef as ReactComponent };